/**
 * Matches strings with {value}.
 * @type {RegExp}
 */
const TEMPLATE_RX = /{{?(#[a-zA-Z]+ )?[a-zA-Z]+.[a-zA-Z]*}?}/gm;

/**
 * Replace all occurrences of the key pairs in the input string.
 * Currently it is formating names only, but could be expanded on for any string.
 * This is meant to replace some react-intl functionality.
 * @param input {String}
 * @param values {Object}
 * @returns {String|Array}
 */

const templateString = (input, values) => {
  if (!values) return input;
  const segments = [];
  let match;
  let pointer = 0;

  // If a value is detected as a non-string,
  // returns the array instead of completed string.
  let isOnlyString = true;

  while ((match = TEMPLATE_RX.exec(input)) !== null) {
    if (match.index > pointer) {
      segments.push(input.slice(pointer, match.index));
    }
    const endIndex = match.index + match[0].length;
    const key = match[0].slice(1, match[0].length - 1);
    const value = values[key] || '';
    if (typeof value !== 'string') {
      isOnlyString = false;
    }
    segments.push(values[key]);
    pointer = endIndex;
  }

  // Push the remaining string to the end.
  if (pointer !== input.length) {
    segments.push(input.slice(pointer));
  }
  return isOnlyString ? segments.join('') : segments;
};

export default templateString;
